module.exports = __webpack_public_path__ + "static/media/GnomeCompanyImage.8c92dee5.svg";